import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_SHORT_LINK_STATE,
});

export const createShortLink = (shortLink) => ({
  type: types.CREATE_SHORT_LINK.REQUEST,
  shortLink,
});

export const createShortLinkSuccess = (shortLink) => ({
  type: types.CREATE_SHORT_LINK.SUCCESS,
  shortLink,
});

export const createShortLinkFailure = (error) => ({
  type: types.CREATE_SHORT_LINK.FAILURE,
  error,
});

export const fetchShortLinks = (startDate, endDate) => ({
  type: types.FETCH_SHORT_LINKS.REQUEST,
  startDate,
  endDate,
});

export const fetchShortLinksSuccess = (shortLinks, startDate, endDate) => ({
  type: types.FETCH_SHORT_LINKS.SUCCESS,
  shortLinks,
  startDate,
  endDate,
});

export const fetchShortLinksFailure = (error) => ({
  type: types.FETCH_SHORT_LINKS.FAILURE,
  error,
});
